import type { PublishHandler } from "@bbj-types/window/index.js";
import { Alert, type AlertColor, Slide } from "@mui/material";
import type React from "react";
import { type ReactNode, useCallback, useEffect, useState } from "react";
import { FeedBack } from "./styles";

export const AlertFeedback = () => {
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [severity, setSeverity] = useState<AlertColor>("success");
  const [message, setMessage] = useState<ReactNode>("");

  const handleClose = useCallback((_event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setFeedbackOpen(false);
  }, []);

  const handleFeedback: PublishHandler = useCallback((feedback) => {
    setFeedbackOpen(true);
    const { severity, message } = feedback;
    setSeverity(severity || "success");
    setMessage(message || "Une erreur s'est produite. Veuillez contacter votre administrateur.");
  }, []);

  useEffect(() => {
    window.subscribe("feedback", handleFeedback);
    return () => {
      window.unsubscribe("feedback", handleFeedback);
    };
  });

  return (
    <FeedBack
      open={feedbackOpen}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      TransitionComponent={Slide}
      TransitionProps={{ timeout: 500 }}
    >
      <Alert onClose={handleClose} severity={severity || "info"} variant="filled" sx={{ zIndex: 2000 }}>
        {message}
      </Alert>
    </FeedBack>
  );
};
